export namespace ResetPasswordResendOtpNamespace {
  export interface IN {
    requestKey: string;
    recaptchaToken: string;
  }

  export class OUT {}
}
